export default __webpack_public_path__ + "static/media/Medeata200blueSymbol.1bcdb936.svg";